import { useQuery } from "@tanstack/react-query";
import { Col, Flex, Row } from "antd";
import { useParams } from "react-router-dom";
import { fetchServicePartnerById } from "@/lib/api/resources/servicePartners";
import { ServicePartner } from "@rumble-it/common-lib/types/models/ServicePartner.interface";
import { ServicepartnerDetailCard } from "./components/ServicepartnerDetailCard";

export const ServicepartnerDetail = () => {
  const { id } = useParams();
  if (!id) return null;

  const servicePartnerQuery = useQuery<ServicePartner>({
    queryKey: ["service-partner", id],
    queryFn: () => fetchServicePartnerById(id!),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col flex="auto">
          <Flex vertical gap={16}>
            <ServicepartnerDetailCard
              id={id}
              data={servicePartnerQuery.data}
              loading={servicePartnerQuery.isFetching}
            />
          </Flex>
        </Col>
        {/* TODO:Check whether this is in use, possibly delete this functionality */}
        {/* <Col flex="400px">
          <Flex vertical gap={16}>
            <Card title="Acties">
              <Flex gap={8} wrap>
                <Link to={`/service-partners/partners/${id}/change-request`}>
                  <Button block>Wijziging basisgegevens aanvragen</Button>
                </Link>
              </Flex>
            </Card>
          </Flex>
        </Col> */}
      </Row>
    </div>
  );
};
